import Axios, { AxiosPromise } from 'axios'

export class AuthService {
  login (username: string, password: string): AxiosPromise<{accessToken: string}> {
    return Axios.post('/login', { username, password })
  }
}
